import { navigate } from "gatsby"
import React from "react"
import {
  MobilePageHeights,
  PageRoutesMap,
  PageSections,
} from "../../../../../types/routes"
import finalRoute from "../../../../../utils/finalRoute"
import getRoute from "../../../../../utils/getRoute"

type Props = {
  isOpen: boolean
  section: PageSections
}

const SubList = ({ isOpen, section }: Props) => {
  return (
    <ul
      className={`transition-all delay-150 duration-300 overflow-hidden w-full ${
        isOpen ? `${MobilePageHeights[section]}` : "h-0"
      }`}
    >
      {PageRoutesMap[section].map((item, i) => (
        <li
          key={i}
          className={`pt-3 cursor-pointer font-raleway-medium font-medium text-base text-center ${
            item.route === finalRoute(getRoute())
              ? "text-igem-green"
              : "text-white"
          } text-white hover:text-igem-green`}
          onClick={() => {
            navigate(`/${item.route}`)
          }}
        >
          {item.label}
        </li>
      ))}
    </ul>
  )
}

export default SubList
